import { missingWidget } from '../utils/helpers';
import MicroModal from 'micromodal';

export default function homepagePopUp() {
  const widgetName = 'homepagePopUp';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof homepagePopUpOpts === 'undefined' ? null : homepagePopUpOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createHomepagePopUp(data.items[0]);
      }
      $widget.remove();
    },
  });

  function createHomepagePopUp(widgetData) {
    const { Description } = widgetData;
    let optionalTitle = Description
      ? `<h2 class="modal__title" id="signup-modal-title">${Description}</h2>`
      : '';
    // template
    function initializePopupModal() {
      $('body').append(`
        <div class="modalPopUp micromodal-slide" id="signup-modal" aria-hidden="true">
          <div class="modal__overlay" tabindex="-1">
            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="signup-modal-title">
              <header class="modal__header">
                ${optionalTitle}
                <button class="button modal__close" aria-label="Close modal" data-micromodal-close></button>
              </header>
              <main class="modal__content" id="signup-modal-content">
                <iframe src="${FULLCLIENTTHEMEPATH}static/popup.html?sv=${SITEVERSION}" frameborder="0" id="popupIframe"></iframe>
              </main>
            </div>
          </div>
        </div>

    `);
      MicroModal.init({
        onClose: () => {
          document.activeElement?.blur();

          setTimeout(() => {
            $('#signup-modal').remove();
          }, 100);
        },
        openClass: 'is-open',
        disableScroll: true,
        disableFocus: false,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        debugMode: false,
      });

      setTimeout(() => {
        MicroModal.show('signup-modal');
      }, 300);
    }

    // Close the popup

    if (navigator.cookieEnabled && $('#modal') && $('body').hasClass('homepage')) {
      if (Cookies.get('modalCookie')) {
        return false;
      } else {
        Cookies.set('modalCookie', 'modalCookie', { expires: 15 });
        initializePopupModal();
      }
    }
  }
}
